/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Offersdescription1Inputs */

const id_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entri etalase di sandbox ini, termasuk game dasar, edisi, DLC, add-on, bundel, dan penawaran apa pun yang dapat memberikan item katalog.`)
};

const ms_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entri kedai dalam sandbox ini, termasuk permainan asas, edisi, DLC, add-on, bundle, dan sebarang tawaran yang boleh memberikan item katalog.`)
};

const da_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butiksposter i denne sandbox, inklusive basisspil, udgaver, DLC, add-ons, bundter og ethvert tilbud der kan tildele katalog-items.`)
};

const de_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront-Einträge in dieser Sandbox, einschließlich Basisspiele, Editionen, DLCs, Add-ons, Bundles und jedes Angebot, das Katalog-Items gewähren kann.`)
};

const en_us2_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront entries in this sandbox, including base games, editions, DLC, add-ons, bundles, and any offer that can grant catalog items.`)
};

const es_es2_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entradas de tienda en este sandbox, incluyendo juegos base, ediciones, DLC, complementos, bundles y cualquier oferta de catálogo que pueda otorgar ítems.`)
};

const es_mx2_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entradas de tienda en este sandbox, incluyendo juegos base, ediciones, DLC, complementos, paquetes y cualquier oferta que pueda otorgar ítems de catálogo.`)
};

const fil_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga entry sa storefront sa sandbox na ito, kasama ang base games, editions, DLC, add-ons, bundle, at anumang offer na maaaring magbigay ng mga item sa catalog.`)
};

const fr_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrées de la vitrine dans ce sandbox, incluant jeux de base, éditions, DLC, extensions, bundles et toute offre de catalogue pouvant octroyer des items de catalogue.`)
};

const it_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voci del negozio in questo sandbox, inclusi giochi base, edizioni, DLC, aggiunte, bundle e qualsiasi offerta che possa concedere articoli del catalogo.`)
};

const hu_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boltfront bejegyzések ebben a sandbox-ban, beleértve az alapjátékokat, kiadásokat, DLC-ket, kiegészítőket, csomagokat és bármely ajánlatot, amely katalóguselemeket biztosíthat.`)
};

const nl_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Winkelvermeldingen in deze sandbox, inclusief basisspellen, edities, DLC, add-ons, bundels en elk aanbod dat catalogusitems kan verlenen.`)
};

const no_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butikkoppføringer i denne sandboxen, inkludert grunnspill, utgaver, DLC, tillegg, bunter og alle tilbud som kan gi katalogelementer.`)
};

const pl_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wpisy sklepowe w tym sandboxie, w tym gry podstawowe, edycje, DLC, dodatki, pakiety i wszelkie oferty, które mogą przyznawać elementy katalogu.`)
};

const pt_br2_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entradas da loja neste sandbox, incluindo jogos base, edições, DLC, complementos, bundles e qualquer oferta de catálogo que possa conceder itens.`)
};

const pt_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registos de loja nesta sandbox, incluindo jogos base, edições, DLC, complementos, pacotes e qualquer oferta que possa conceder itens de catálogo.`)
};

const ro_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Înregistrări din magazin în acest sandbox, inclusiv jocuri de bază, ediții, DLC-uri, add-on-uri, pachete și orice ofertă care poate acorda elemente de catalog.`)
};

const fi_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kauppapaikan merkinnät tässä hiekkalaatikossa, mukaan lukien peruspelit, versiot, DLC:t, lisäosat, paketit ja kaikki tarjoukset, jotka voivat myöntää katalogikohteita.`)
};

const sv_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butiksposter i denna sandlåda, inklusive grundspel, utgåvor, DLC, tillägg, paket och alla erbjudanden som kan ge katalogobjekt.`)
};

const vi_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các mục cửa hàng trong sandbox này, bao gồm game cơ bản, phiên bản, DLC, tiện ích mở rộng, gói và bất kỳ ưu đãi nào có thể cấp mục danh mục.`)
};

const tr_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu sandbox'taki mağaza girişleri; temel oyunlar, sürümler, DLC, eklentiler, paketler ve katalog öğeleri sağlayabilen herhangi bir teklif.`)
};

const cs_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Položky obchodu v tomto sandboxu, včetně základních her, edic, DLC, doplňků, balíčků a jakékoli nabídky, která může udělovat katalogové položky.`)
};

const bg_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Магазинни записи в този sandbox, включително основни игри, издания, DLC, добавки, пакети и всяка оферта, която може да предоставя каталог обекти.`)
};

const ru_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Товары на витрине в этой песочнице, включая базовые игры, различные издания игр, DLC, дополнения, комплекты игр и любые предложения, которые могут предоставить доступ к предметам из каталога.`)
};

const uk_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записи магазину в цьому Sandbox, включаючи базові ігри, видання, DLC, доповнення, набори та будь-які пропозиції, які можуть надавати елементи каталогу.`)
};

const ar_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجلات المتجر في Sandbox هذا، بما في ذلك الألعاب الأساسية والإصدارات و DLC والإضافات والحزم وأي عرض يمكنه منح عناصر الكتالوج.`)
};

const hi_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस सैंडबॉक्स में स्टोरफ्रंट प्रविष्टियाँ, जिनमें बेस गेम, संस्करण, DLC, ऐड-ऑन, बंडल, और कोई भी ऑफ़र शामिल है जो कैटलॉग आइटम प्रदान कर सकता है।`)
};

const th_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการหน้าร้านในแซนด์บ็อกซ์นี้ รวมถึงเกมหลัก รุ่นพิเศษ DLC ส่วนเสริม บันเดิล และข้อเสนอใด ๆ ที่สามารถให้รายการแค็ตตาล็อกได้`)
};

const ja_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このサンドボックス内のストアフロントエントリー。ベースゲーム、エディション、DLC、アドオン、バンドル、カタログアイテムを付与できるあらゆるオファーを含みます。`)
};

const zh_cn2_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此沙盒中的商店条目，包括基础游戏、版本、DLC、附加内容、捆绑包以及任何可以授予目录项的目录项。`)
};

const zh_hant1_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此沙盒中的商店條目，包括基礎遊戲、版本、DLC、附加內容、捆綁包以及任何可以授予目錄項目的目錄項目。`)
};

const ko_sandboxes_offersdescription1 = /** @type {(inputs: Sandboxes_Offersdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 Sandbox의 스토어프론트 항목으로, 기본 게임, 에디션, DLC, 애드온, 번들 및 카탈로그 아이템을 부여할 수 있는 모든 오퍼를 포함합니다.`)
};

/**
* | output |
* | --- |
* | "Storefront entries in this sandbox, including base games, editions, DLC, add-ons, bundles, and any offer that can grant catalog items." |
*
* @param {Sandboxes_Offersdescription1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_offersdescription1 = /** @type {((inputs?: Sandboxes_Offersdescription1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Offersdescription1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_offersdescription1(inputs)
	if (locale === "ms") return ms_sandboxes_offersdescription1(inputs)
	if (locale === "da") return da_sandboxes_offersdescription1(inputs)
	if (locale === "de") return de_sandboxes_offersdescription1(inputs)
	if (locale === "en-US") return en_us2_sandboxes_offersdescription1(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_offersdescription1(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_offersdescription1(inputs)
	if (locale === "fil") return fil_sandboxes_offersdescription1(inputs)
	if (locale === "fr") return fr_sandboxes_offersdescription1(inputs)
	if (locale === "it") return it_sandboxes_offersdescription1(inputs)
	if (locale === "hu") return hu_sandboxes_offersdescription1(inputs)
	if (locale === "nl") return nl_sandboxes_offersdescription1(inputs)
	if (locale === "no") return no_sandboxes_offersdescription1(inputs)
	if (locale === "pl") return pl_sandboxes_offersdescription1(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_offersdescription1(inputs)
	if (locale === "pt") return pt_sandboxes_offersdescription1(inputs)
	if (locale === "ro") return ro_sandboxes_offersdescription1(inputs)
	if (locale === "fi") return fi_sandboxes_offersdescription1(inputs)
	if (locale === "sv") return sv_sandboxes_offersdescription1(inputs)
	if (locale === "vi") return vi_sandboxes_offersdescription1(inputs)
	if (locale === "tr") return tr_sandboxes_offersdescription1(inputs)
	if (locale === "cs") return cs_sandboxes_offersdescription1(inputs)
	if (locale === "bg") return bg_sandboxes_offersdescription1(inputs)
	if (locale === "ru") return ru_sandboxes_offersdescription1(inputs)
	if (locale === "uk") return uk_sandboxes_offersdescription1(inputs)
	if (locale === "ar") return ar_sandboxes_offersdescription1(inputs)
	if (locale === "hi") return hi_sandboxes_offersdescription1(inputs)
	if (locale === "th") return th_sandboxes_offersdescription1(inputs)
	if (locale === "ja") return ja_sandboxes_offersdescription1(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_offersdescription1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_offersdescription1(inputs)
	return ko_sandboxes_offersdescription1(inputs)
});
export { sandboxes_offersdescription1 as "sandboxes.offersDescription" }